import React, { useEffect, useState } from "react";

// import { toast } from "react-toastify";
import { HashLoader } from "react-spinners";

// import "react-toastify/dist/ReactToastify.css";

const Loader = (props) => {
  return (
    <React.Fragment>
      <div
        className="position-fixed top-0 start-0 w-100 h-100 bg-white bg-opacity-75 d-flex justify-content-center align-items-center z-3"
        style={{
          transition: "opacity 0.3s ease-in-out",
          opacity: 1,
        }}
      >
        <HashLoader color="#1c5a21" />
      </div>
    </React.Fragment>
  );
};

export default Loader;
